import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import backgroundImg from './img/background.png'
import backgroundMobile from './img/background-mobile.png'
import ornamentStars from './img/ornament-stars.png'

const Intro = ({
  coupleData: { coupleSimplifiedName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro356">
      <input
        type="hidden"
        id="anPageName"
        name="page"
        value="animated-intro-small-all-breakpoints"
      />
      <div className="animated-intro-large screen">
        <img
          className="background-p4EdWL"
          src={background || backgroundImg}
          alt="Background"
          style={{ objectFit: background ? 'cover' : 'fill' }}
        />
        <img
          className="ornament-stars-p4EdWL bp1-animate-enter"
          src={ornamentStars}
          alt="Ornament - Stars"
        />
        <div className="button-p4EdWL">
          <div
            className="site-de-casamento-e-CpwLjN"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-CpwLjN smart-layers-pointers">
            <div
              className="pular-introduo-fo8x79 helveticaneue-medium-white-12px"
              onClick={onSkipIntro}
            >
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-p4EdWL notranslate">
          <div className="m-e-VF7rnS josefinslab-normal-white-72px-2 bp1-animate-enter1">
            <span className="span0-cOk0Lc josefinslab-normal-mine-shaft-72px">
              {coupleSimplifiedName.bride}
            </span>
            <span className="span1-cOk0Lc josefinslab-normal-white-72px">
              &nbsp;
            </span>
            <span className="span2-cOk0Lc josefinslab-normal-desert-sand-72px">
              +
            </span>
            <span className="span3-cOk0Lc josefinslab-normal-white-72px">
              &nbsp;
            </span>
            <span className="span4-cOk0Lc josefinslab-normal-mine-shaft-72px">
              {coupleSimplifiedName.groom && coupleSimplifiedName.groom}
            </span>
          </div>
        </div>
      </div>
      <div className="animated-intro-small-all-breakpoints screen">
        <img
          className="background-kaVUlA"
          src={background || backgroundMobile}
          alt="Background"
        />
        <div className="button-kaVUlA">
          <div
            className="site-de-casamento-e-gcDLS5"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <div className="button-gcDLS5 smart-layers-pointers">
            <div
              className="pular-introduo-ZdVp8v helveticaneue-medium-white-12px"
              onClick={onSkipIntro}
            >
              {buttonMessage}
            </div>
          </div>
        </div>
        <div className="couple-name-kaVUlA bp2-animate-enter1 notranslate">
          <div className="m-e-zk2cMo josefinslab-normal-white-72px-2 bp2-animate-enter">
            <span className="span0-BQxbh2 josefinslab-normal-mine-shaft-72px">
              {coupleSimplifiedName.bride}
            </span>
            <span className="span1-BQxbh2 josefinslab-normal-white-72px">
              &nbsp;
            </span>
            <span className="span2-BQxbh2 josefinslab-normal-desert-sand-72px">
              +
            </span>
            <span className="span3-BQxbh2 josefinslab-normal-white-72px">
              &nbsp;
            </span>
            <span className="span4-BQxbh2 josefinslab-normal-mine-shaft-72px">
              {coupleSimplifiedName.groom && coupleSimplifiedName.groom}
            </span>
          </div>
        </div>
        <img
          className="ornament-stars-kaVUlA"
          src={ornamentStars}
          alt="Ornament - Stars"
        />
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
